"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@focaltec-suite/core");
var _api = require("@focaltec-suite/api");
var _commons = require("@focaltec-suite/commons");
var _ExtendedFieldInput = _interopRequireDefault(require("./ExtendedFieldInput"));
var _material = require("@mui/material");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ExtendedFieldFormPopup(_ref) {
  var tenantId = _ref.tenantId,
    access = _ref.access,
    item = _ref.item,
    catalogs = _ref.catalogs,
    s3Client = _ref.s3Client,
    onUpdated = _ref.onUpdated,
    onClose = _ref.onClose,
    disabled = _ref.disabled;
  var feedbackContext = (0, _react.useContext)(_commons.FeedbackContext);
  var _useValidatedForm = (0, _commons.useValidatedForm)(),
    isValid = _useValidatedForm.isValid,
    register = _useValidatedForm.register,
    bind = _useValidatedForm.bind;
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    url = _useState2[0],
    setUrl = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    loading = _useState4[0],
    setLoading = _useState4[1];
  (0, _react.useEffect)(function () {
    if (item.field.type === 'FILE' && item.value) {
      setLoading(true);
      (0, _api.secure)({
        http_method: 'GET',
        key: item.value,
        tenant_id: tenantId,
        temporal: false,
        seconds: 600
      }, {
        access: access
      }).then(function (response) {
        setUrl(response.url);
      })["catch"](function (error) {
        feedbackContext.showWarning(error.message);
      })["finally"](function () {
        setLoading(false);
      });
    }
  }, [item, tenantId, access, feedbackContext]);
  var submit = function submit() {
    if (!isValid()) return;
    var request = bind();
    var value = request[item.field.id];
    if (!value) {
      onUpdated(undefined);
      return;
    }
    switch (item.field.type) {
      case 'DATE':
        onUpdated((0, _commons.formatDate)({
          date: value
        }));
        break;
      case 'DATETIME':
        onUpdated((0, _commons.formatDateTime)({
          date: value
        }));
        break;
      case 'INTEGER':
      case 'NUMBER':
        onUpdated(value);
        break;
      default:
        onUpdated(value);
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_commons.DialogPopup, {
    title: item.field.name,
    onClose: onClose,
    button: {
      text: (0, _core.translate)('buttons.update'),
      onClick: submit,
      disabled: disabled
    },
    leftButton: item.field.type === 'FILE' ? {
      text: (0, _core.translate)('buttons.download'),
      href: url,
      disabled: !url,
      loading: loading
    } : undefined
  }, item.field.description && /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "body2",
    paragraph: true
  }, item.field.description), /*#__PURE__*/_react["default"].createElement(_ExtendedFieldInput["default"], {
    value: item.value,
    extendedField: item.field,
    register: register,
    s3Client: s3Client,
    disabled: disabled,
    catalogs: catalogs
  }));
}
var _default = exports["default"] = ExtendedFieldFormPopup;